import { observable } from 'mobx';

export type LegSummaryTerminalResponseArgs = {
  name: string;
  express_station: string | null;
  time: string;
};

export type LegSummaryTerminalArgs = {
  name: string;
  expressStation: string | null;
  time: string;
};

export const convertLegSummaryTerminalResponseToArgs = (response: LegSummaryTerminalResponseArgs) => {
  const args: LegSummaryTerminalArgs = {
    name: response.name,
    expressStation: response.express_station,
    time: response.time
  };
  return args;
};

export default class LegSummaryTerminal {
  @observable name: string;
  @observable expressStation: string | null;
  @observable time: string;

  constructor(args: LegSummaryTerminalArgs) {
    this.name = args.name;
    this.expressStation = args.expressStation;
    this.time = args.time;
  }
}
